import React, { Component } from 'react';
import Vas from '../../../Vas';
import '../../../css/CustomerCreateContract.css';
import { LinkButton } from 'component-lib';

class ChangeEmailSuccess extends Component
{

  constructor(props)
  {
    super(props);
    this.state = {};
    this.CustomerId = props.match.params.CustomerId;
  }
 
  Cancel(){
    Vas.GetView("CustomerCardData",{Id:this.CustomerId},true);
  }

  render()
  {
    return (
      <div className={"form changeEmailSuccessForm"}>
        <table >
          <thead>
            <tr>
              <th style={{fontSize:'large',width:'400px'}} colSpan={2}>
                {Vas.Resources.Labels["EmailChanged"]}
                <br />
                <br />
              </th>
            </tr>
          </thead>
        <tbody>
          <tr></tr>
          <tr>
          <td style={{ fontSize:'14px', float: 'right' }}>{Vas.Resources.Labels["LinkLoginFemininum"]}</td>
              <td>
                  <LinkButton 
                  Text={Vas.Resources.Labels["OverviewCustumerData"]} 
                  Id={"LinkLogin"} 
                  OnClick={()=>{Vas.GetView("CustomerCard",{ Id:this.CustomerId },true);}} />
              </td>
          </tr>
        </tbody>
      </table>
      </div>
      
    );
  }
}
export default ChangeEmailSuccess;
